module.exports = __webpack_public_path__ + "media/images/photos/interior-61976c56674bec808c467b403a6a3baf.jpg";